import { useCurrentUser } from '@hotjar/user';
import { HEATMAPS } from '@hotjar/webapp/constants/routes';
import { useDismiss } from '@hotjar/webapp/hooks/useDismiss';
import { useUserExperiment } from '@hotjar/webapp/hooks/useExperiment';
import { useRecentSurveys } from '@hotjar/webapp/hooks/useRecentSurveys';
import { getRouteConfigByPath } from '@hotjar/webapp/utils/routing';
import { useLocation } from 'react-router-dom';
import { useHasSeenMultipleHeatmaps } from '@hotjar/webapp/features/Activation/FeedbackHeatmapsPopup/useHasSeenMultipleHeatmaps';
import { narrowIncludes } from '@hotjar/insights-common/lib/arrays';
import { APP_STATE_NAMESPACE } from '../FloatingSuggestions/constants';

interface UseFeedbackHeatmapsPopup {
  isEnabled: boolean;
  dismiss: () => void;
}

export const useFeedbackHeatmapsPopup = (): UseFeedbackHeatmapsPopup => {
  const location = useLocation();
  const inHeatmapsPage = narrowIncludes(
    [HEATMAPS.LIST.name, HEATMAPS.LIST_CONTINUOUS_CAPTURE.name],
    getRouteConfigByPath(location.pathname)?.name || '',
  );
  const { isDismissed, dismiss } = useDismiss(APP_STATE_NAMESPACE, 'feedback_heatmaps_popup');

  const { data: surveys, isLoading, isError } = useRecentSurveys();
  const hasEnabledSurveys = !isError && surveys?.some(({ enabled }) => enabled) === true;

  const hasSeenMultipleHeatmaps = useHasSeenMultipleHeatmaps();

  const canSeePopup =
    hasSeenMultipleHeatmaps === true &&
    !isDismissed &&
    inHeatmapsPage &&
    !isLoading &&
    !hasEnabledSurveys;

  const { data: user } = useCurrentUser();
  const { inVariant1: isInExperiment } = useUserExperiment(
    'feedback_heatmaps_popup',
    user,
    canSeePopup,
  );

  const isEnabled = isInExperiment && canSeePopup;

  return { isEnabled, dismiss };
};
